import { render, staticRenderFns } from "./ListaBanner.vue?vue&type=template&id=0665c8df"
import script from "./ListaBanner.vue?vue&type=script&lang=js"
export * from "./ListaBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports